import React from "react";
import Input from "../bootstrap/forms/Input";
import Modal, { ModalBody, ModalHeader } from "../bootstrap/Modal";
import Icon from "../icon/Icon";
import PropTypes from 'prop-types';

const SearchPopUp = ({setSearchModalStatus,filterResult,valueInput,curentInput,handelChange, handelSelect}) => {
    
    return (
        <Modal
            setIsOpen={()=>{}}
            isOpen={true}
            isStaticBackdrop
            isScrollable
            data-tour='search-modal'
            classNameMd="nv-3"
            >
            <ModalHeader setIsOpen={setSearchModalStatus}>
                <label className='border-0 bg-transparent cursor-pointer' htmlFor='searchInput'>
                    <Icon icon='Search' size='2x' color='primary' />
                </label>
                <Input
                    
                    name={curentInput?.inputName||"search"}
                    className='border-0 shadow-none bg-transparent'
                    placeholder='Search...'
                    value={valueInput[curentInput?.inputName]}
                    onChange={handelChange}
                    autoComplete="off"
                />
            </ModalHeader>
            <ModalBody>
                <table className='table table-hover table-modern caption-top mb-0'>
                    <caption>Results: {filterResult[curentInput?.inputName]?.length}</caption>
                    <thead style={{ top: -13 }}>
                        <tr>
                            <th scope='col'>{curentInput?.inputLabel||"Results"}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterResult[curentInput?.inputName]?.length ? (
                            filterResult[curentInput?.inputName]?.map((item) => (
                                <tr
                                    key={item?.id}
                                    className='cursor-pointer'
                                    onClick={() => {
                                        handelSelect({value:{[curentInput?.inputName]:item?.name||item?.display_name},selected:{[curentInput?.inputName]:item}});
                                    }}
                                >
                                    <td className="row">
                                        {/* {item.id && (
                                            <Icon
                                                icon={item.id}
                                                size='lg'
                                                className='me-2'
                                                color='primary'
                                            />
                                        )} */}
                                        <span className="col">
                                            {item?.id}
                                        </span>
                                        <span className="col">
                                            {item?.name||item?.display_name}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className='table-active'>
                                <td>No result found for query </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </ModalBody>
        </Modal>
    )
};

SearchPopUp.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	// @ts-ignore
	setSearchModalStatus: PropTypes.func.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	filterResult: PropTypes.object.isRequired,
    valueInput:PropTypes.object,
    curentInput:PropTypes.object,
    handelChange:PropTypes.func,
    handelSelect:PropTypes.func
    /* selectedValue:PropTypes.object */
};

export default SearchPopUp;